/**
 * Loads every investment program once for the 项目参数 and 叠加关系 tabs, and tells a
 * denial (caller is not a Deal Desk admin — retrying cannot help) apart from other failures.
 * `includeDisabled` also loads disabled programs (项目参数 lists them; 叠加关系 does not).
 */
import { useCallback, useEffect, useState } from 'react';

import { getCpaClient, type InvestmentProgramData } from '../client/CpaClient';
import { isAccessDenied, listAllPrograms } from '../utils/programs';

export type ProgramsState =
  | { kind: 'loading' }
  | { kind: 'ready'; programs: InvestmentProgramData[] }
  | { kind: 'denied' }
  | { kind: 'error'; message: string };

export function usePrograms(includeDisabled = false): { state: ProgramsState; reload: () => void } {
  const [state, setState] = useState<ProgramsState>({ kind: 'loading' });

  const reload = useCallback(() => {
    setState({ kind: 'loading' });
    listAllPrograms(getCpaClient(), undefined, includeDisabled)
      .then((programs) => setState({ kind: 'ready', programs }))
      .catch((e: unknown) =>
        setState(
          isAccessDenied(e)
            ? { kind: 'denied' }
            : { kind: 'error', message: e instanceof Error ? e.message : String(e) },
        ),
      );
  }, [includeDisabled]);

  useEffect(reload, [reload]);

  return { state, reload };
}
